<form
  [formGroup]="outputForm"
  (ngSubmit)="saveOutput()"
  autocomplete="on"
  class="container-grid"
  [ngStyle]="containerStyles"
>
  <div class="grid-first">
    <label for="tipo-salida-opcion" class="form-label">Tipo de salida*</label>
    <select
      id="tipo-salida-opcion"
      class="form-control"
      [formControl]="tipoSalida"
      *ngIf="movimiento == 'crear'"
    >
      <option *ngFor="let item of outputTypes" [value]="item.id">
        {{ item.description }}
      </option>
    </select>
    <select
      id="tipo-salida-opcion"
      class="form-control"
      formControlName="output_type_option_id"
      *ngIf="movimiento !== 'crear'"
    >
      <option *ngFor="let item of outputTypes" [value]="item.id">
        {{ item.description }}
      </option>
    </select>
  </div>
  <div class="empty-container"></div>
  <div class="empty-container"></div>
  <div class="empty-container" *ngIf="movimiento == 'crear'"></div>
  <div *ngIf="movimiento !== 'crear'">
    <label for="noOperacion" class="form-label">No. de operación*</label>
    <input
      type="number"
      id="noOperacion"
      class="form-control"
      [value]="id"
      disabled
    />
  </div>
  <div>
    <label for="nombreChecador" class="form-label">Nombre del checador</label>
    <input
      type="text"
      id="nombreChecador"
      class="form-control"
      maxlength="150"
      formControlName="checker_name"
    />
  </div>
  <div>
    <label for="clave-recinto" class="form-label">Clave del recinto*</label>
    <input
      type="number"
      id="clave-recinto"
      class="form-control"
      formControlName="precinct_key"
    />
  </div>
  <div class="grid-first">
    <label for="destino" class="form-label">Destino*</label>
    <select
      id="destino"
      class="form-control"
      formControlName="destination_id"
    >
      <option value="">-- Seleccione Destino --</option>
      <option *ngFor="let item of nationalPorts" [value]="item.id">
        {{ item.description }}
      </option>
    </select>
    <span
      class="form-text text-danger"
      *ngIf="campoEsValido('destination_id')"
    >
      Ingrese el destino
    </span>
  </div>
  <div>
    <label for="fechaRecinto" class="form-label">Fecha de salida*</label>
    <input
      type="date"
      id="fechaRecinto"
      class="form-control"
      formControlName="departure_date"
    />
    <span
      class="form-text text-danger"
      *ngIf="campoEsValido('departure_date')"
    >
      Ingrese la fecha
    </span>
  </div>
  <div>
    <label for="noBarco" class="form-label">No. de barco*</label>
    <select
      id="noBarco"
      class="form-control"
      formControlName="ship_number"
      (change)="changeBoat()"
    >
      <option value="">-- Seleccione un número de barco --</option>
      <option *ngFor="let boat of boats" [value]="boat.boats_number">
        {{ boat.boats_number }}
      </option>
    </select>
    <span
      class="form-text text-danger"
      *ngIf="campoEsValido('ship_number')"
    >
      Seleccione número de barco
    </span>
  </div>
  <div class="grid-first">
    <label for="nombreBarco" class="form-label">Nombre del barco*</label>
    <input
      type="text"
      id="nombreBarco"
      class="form-control"
      maxlength="150"
      formControlName="ship_name"
    />
    <span
      class="form-text text-danger"
      *ngIf="campoEsValido('ship_name')"
    >
      Ingrese el nombre del barco
    </span>
  </div>
  <div>
    <label for="tonelaje" class="form-label">Tonelaje total*</label>
    <input
      type="text"
      id="tonelaje"
      class="form-control"
      formControlName="total_tonnage"
      maxlength="15"
      appBlockLetters
    />
    <span
      class="form-text text-danger"
      *ngIf="campoEsValido('total_tonnage')"
    >
      Ingrese tonelaje valido
    </span>
  </div>
  <div>
    <label for="piezas" class="form-label">Piezas</label>
    <input
      type="text"
      id="piezas"
      class="form-control"
      appOnlyNumbers
      [maxDigits]="10"
      formControlName="total_pieces"
    />
    <span
      class="form-text text-danger"
      *ngIf="campoEsValido('total_pieces')"
    >
      Ingrese las piezas
    </span>
  </div>
  <app-amounts-by-input-locations
    class="subtitle"
    [movimiento]="movimiento"
    [locations]="locations"
    [amountsPerYardList]="amountsPerYardList"
    [entryTonnage]="outputForm.get('total_tonnage')?.value"
    [entryPieces]="outputForm.get('total_pieces')?.value"
    [outputDetail]="outputDetail"
  ></app-amounts-by-input-locations>
  <div class="grid-first">
    <label for="empresaDestinatario" class="form-label">Empresa destino*</label>
    <input
      type="text"
      id="empresaDestinatario"
      class="form-control"
      maxlength="200"
      formControlName="destination_company"
    />
    <span
      class="form-text text-danger"
      *ngIf="campoEsValido('destination_company')"
    >
      Ingrese la empresa destino
    </span>
  </div>
  <div>
    <label for="destinatario" class="form-label">Domicilio de la empresa destino*</label>
    <input
      type="text"
      id="destinatario"
      class="form-control"
      maxlength="150"
      formControlName="addressee"
    />
    <span
      class="form-text text-danger"
      *ngIf="campoEsValido('addressee')"
    >
      Ingrese el domicilio
    </span>
  </div>
  <div class="grid-first">
    <label for="nombreConsignatario" class="form-label">
      Nombre del consignatario
    </label>
    <input
      type="text"
      id="nombreConsignatario"
      class="form-control"
      formControlName="consignee_name"
      maxlength="100"
    />
    <span
      class="form-text text-danger"
      *ngIf="campoEsValido('consignee_name')"
    >
      Ingrese el nombre
    </span>
  </div>
  <div class="grid-span2">
    <label for="domicilioConsignatario" class="form-label">
      Domicilio del consignatario
    </label>
    <input
      type="text"
      id="domicilioConsignatario"
      class="form-control"
      formControlName="address_consignee"
      maxlength="150"
    />
    <span
      class="form-text text-danger"
      *ngIf="campoEsValido('address_consignee')"
    >
      Ingrese el domicilio del consignatario
    </span>
  </div>
  <div class="grid-all container-button">
    <button
      type="button"
      class="btn-lote me-5"
      (click)="regresar()"
      *ngIf="movimiento !== 'crear'"
    >
      Regresar
    </button>
    <button
      type="submit"
      class="btn-lote ms-5"
      *ngIf="movimiento !== 'detalle'"
    >
      Guardar
    </button>
  </div>
</form>
<app-overlay
  *ngIf="overlay"
  [icono]="iconoOverlay"
  [mensaje]="mensajeOverlay"
  [buttons]="buttons"
></app-overlay>
<app-overlay
  *ngIf="loading"
></app-overlay>
